import { render } from "./FileViewerWithVersions.vue?vue&type=template&id=ee00498e&scoped=true"
import script from "./FileViewerWithVersions.vue?vue&type=script&lang=js"
export * from "./FileViewerWithVersions.vue?vue&type=script&lang=js"

import "./FileViewerWithVersions.vue?vue&type=style&index=0&id=ee00498e&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee00498e"]])

export default __exports__